export const tableThemes = {
	LIGHT: "table-theme-light",
	DARK: "table-theme-dark",
};
